import { EmptyState as MatchboxEmptyState } from '@sparkpost/matchbox';

/**
 * Matchbox EmptyState component
 * @see https://design.sparkpost.com/components/emptystate/
 */

export default MatchboxEmptyState;
